import React, { useState } from "react";
import { User, LogIn } from "lucide-react";

const Account = () => {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", firstName: "", lastName: "" });
  const [message, setMessage] = useState("");

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(mode === "login" ? "Login successful (demo mode)." : "Account created successfully (demo mode).");
  };

  return (
    <div className="py-20 bg-p3-cream min-h-[60vh]">
      <div className="max-w-md mx-auto px-5">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-p3-navy/5 flex items-center justify-center mx-auto mb-4">
            <User size={26} className="text-p3-blue" />
          </div>
          <h1 className="font-heading font-extrabold text-3xl text-p3-navy">My Account</h1>
        </div>

        <div className="flex bg-white rounded-lg overflow-hidden shadow-sm mb-6">
          <button
            onClick={() => { setMode("login"); setMessage(""); }}
            className={`flex-1 py-3 text-sm font-semibold transition-colors ${mode === "login" ? "bg-p3-navy text-white" : "text-p3-navy"}`}
          >
            Login
          </button>
          <button
            onClick={() => { setMode("register"); setMessage(""); }}
            className={`flex-1 py-3 text-sm font-semibold transition-colors ${mode === "register" ? "bg-p3-navy text-white" : "text-p3-navy"}`}
          >
            Register
          </button>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-8 space-y-4">
          {mode === "register" && (
            <div className="grid grid-cols-2 gap-4">
              <input name="firstName" value={form.firstName} onChange={handleChange} placeholder="First name" className="px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-p3-blue/40" />
              <input name="lastName" value={form.lastName} onChange={handleChange} placeholder="Last name" className="px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-p3-blue/40" />
            </div>
          )}
          <input required type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email" className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-p3-blue/40" />
          <input required type="password" name="password" value={form.password} onChange={handleChange} placeholder="Password" className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-p3-blue/40" />
          <button type="submit" className="w-full flex items-center justify-center gap-2 bg-p3-gold hover:bg-p3-gold/90 text-p3-navy font-semibold py-3 rounded-lg transition-all">
            <LogIn size={16} /> {mode === "login" ? "Login" : "Create Account"}
          </button>
          {message && <p className="text-sm text-green-600 text-center pt-1">{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default Account;
